import { render } from "./Aboard.vue?vue&type=template&id=7a11f5b5&scoped=true"
import script from "./Aboard.vue?vue&type=script&lang=js"
export * from "./Aboard.vue?vue&type=script&lang=js"

import "./Aboard.vue?vue&type=style&index=0&id=7a11f5b5&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Portfolio/Portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a11f5b5"]])

export default __exports__